<template>
  <div class="alert" :class="flashClass" v-if="message">
    <span v-html="message" />
    <button type="button" class="close" @click="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>
<script>
  export default {
    computed: {
      flashClass () {
        let message = this.$store.getters.message
        return {
          'alert-danger': message && message.type == 'error',
          'alert-success': message && message.type == 'success'
        }
      },
      message () {
        let message = this.$store.getters.message
        if (message && message.text) {
          return message.text
        }
        return ''
      }
    },
    methods: {
      close () {
        this.$store.dispatch('message', null)
      }
    }
  }
</script>
<style scoped lang="scss">
  .alert {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99999999;
    border-radius: 0;
    border: none;
    //font-family: $secondary-font-family;
    color:#fff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: middle;
    .close {
      background-color: transparent;
      border: none;
      margin-left: 15px;
      height: 23px;
      display: block;
      opacity: 1;
      span {
        display: block;
        margin-top: -11px;
        line-height: 42px;
        //font-size: 1.125rem;
        color:#fff;
        //line-height: 28px;
        text-shadow: none;
        opacity: 1;
      }
    }
  }
  .alert-danger {
    background: $error;
  }
  .alert-success {
    background: $success;
  }
  .alert {
    min-height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
